import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectsubscriptionsListItems } from "../../../../redux/subscriptions/selector";
import { subscriptions } from "../../../../redux/subscriptions/action";
import PageLoader from "../../../../components/PageLoader";
import Table from "../../../../common/components/table";
import storePersist from "../../../../redux/storePersist";
import { selectPartnersListItems } from "../../../../redux/partners/selector";
import { partners } from "../../../../redux/partners/action";

const OnePartners = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const partnerItems = useSelector(selectPartnersListItems)
    const userProfileData = storePersist?.get("userProfile")?.current;
    const userProfileId = userProfileData?.items[0]?.Message?.Id
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
  
          { field: 'Name', headerName: 'Name',searchField: 'Name', filter: true,
            filterType: 'text' },
          { field: 'Email', headerName: 'Email',searchField: 'Email', filter: true,
            filterType: 'text' },
          { field: 'PhoneNumber', headerName: 'PhoneNumber',searchField: 'PhoneNumber', filter: false},
          { field: 'Validity', headerName: 'Validity',searchField: 'Validity', filter: false },
          { field: 'OwnerName', headerName: 'Subscription',searchField: 'OwnerName', filter: false },
          { field: 'CreatedOnUtc', headerName: 'Start Date', isDateValueFormat: true },
          { field: 'ModifiedOnUtc', headerName: 'End Date', isDateValueFormat: true },
          
    
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(subscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
            "Filters": [
                {
                  "FieldName": "UserProfileId",
                  "FilterOperatorId": 1,
                  "FieldValue": userProfileId,
                  "FieldType": "number"
                },
            ],
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
   
      const handleReloadData = () => {
        dispatch(subscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,entity:'subscriptions',jsonData:{
            "Filters": [
                {
                  "FieldName": "UserProfileId",
                  "FilterOperatorId": 1,
                  "FieldValue": userProfileId,
                  "FieldType": "number"
                },
            ],
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
  
      const fetchPartners=()=>{
        dispatch(partners.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/partners/list`,entity:'partners',jsonData:{
           
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
     
	useEffect(() => {
        createColumnDefs()
        fetchPartners()
	}, [pageData,pageSize])
   

     
    
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const additionButtons: any = [
  
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];

    
	return (
    <>
    {partnerItems?.isLoading ?  <PageLoader />: 
		<Table  enableFilter={true} 
    onSearch={handleSearch}columnData={columnDefs} rowData={partnerItems?.result?.items} setPageData={setPageData}onEdit={handleEdit}
    setPageSize={setPageSize}paginationData={partnerItems?.result?.pagination} additionButtons={additionButtons} headingName="Partners"/>
     
  }
  </> 
	);
};

export default OnePartners;


